import { RouteType } from "../../../types/RouteType";

const SlumpTestRecordingWorkflowRoute: RouteType = {
  name: "Slump Test Recording",
  path: "/workflows/slump-test-recording",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./SlumpTestRecordingWorkflowHeader"),
      title: "Record Slump Test",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SlumpTestRecordingWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default SlumpTestRecordingWorkflowRoute;
